import { JourneyData, JourneyNavigateOptions, JourneyTarget } from '@cash-web/shared-journey-data-access-context'
import { createSingleUseFlowToken } from '@cash-web/shared-util-fetch'

import { getTargetHistory } from './getTargetHistory'

export type JourneyState = {
  isInProgress: boolean
  history: JourneyData[]
}

export type JourneyAction =
  | {
      type: 'JOURNEY_START'
      replace?: boolean
      path: string
      opts?: JourneyNavigateOptions
    }
  | {
      type: 'JOURNEY_CANCEL'
      journeyId?: string
    }
  | {
      type: 'JOURNEY_COMPLETE'
      journeyId?: string
    }
  | {
      type: 'JOURNEY_IDLE'
      excludeTargets?: JourneyTarget[]
    }

export const journeyPaneReducer = (state: JourneyState, action: JourneyAction): JourneyState => {
  switch (action.type) {
    case 'JOURNEY_START': {
      const targetHistory = getTargetHistory(state.history)
      const lastScope = targetHistory[(action.opts?.scope?.['target'] as JourneyTarget) ?? 'modal'].at(-1)?.opts?.scope // default modal  if no target set

      const history = action.opts?.replace ? state.history.slice(0, -1) : state.history
      // scope is merged from the last journey and the current journey
      const scope = { ...(lastScope ?? {}), ...(action.opts?.scope ?? {}) }
      const currentJourney = {
        journeyId: createSingleUseFlowToken(),
        path: action.path,
        opts: { ...(action.opts ?? {}), scope },
      }

      if (process.env['NODE_ENV'] === 'development') {
        localStorage.setItem(
          'journeys',
          JSON.stringify([
            { ...currentJourney, timeStamp: new Date() },
            ...JSON.parse(localStorage.getItem('journeys') ?? '[]').slice(0, 99),
          ])
        )
      }

      return {
        history: [...history, currentJourney],
        isInProgress: true,
      }
    }
    case 'JOURNEY_CANCEL':
    case 'JOURNEY_COMPLETE': {
      const history = action.journeyId
        ? state.history.filter(h => h.journeyId !== action.journeyId)
        : state.history.slice(0, -1)

      return {
        history,
        isInProgress: history.length > 0,
      }
    }
    case 'JOURNEY_IDLE': {
      const history = action.excludeTargets
        ? state.history.filter(h => action?.excludeTargets?.includes(h.opts?.scope?.['target'] as JourneyTarget))
        : []

      return {
        history,
        isInProgress: history.length > 0,
      }
    }
    default: {
      return state
    }
  }
}
